/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import styles from '../styles/inputs.module.css';

const InputText = ({
  name,
  defaultValue,
  placeholder,
  onChange,
  value
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.box}>
        <input
          name={name}
          defaultValue={defaultValue}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

InputText.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

InputText.defaultProps = {
  defaultValue: '',
  placeholder: '',
};

export default InputText;
